import { DialogComponent } from '@theme/dialog';

/**
 * AMQ badge lightbox (sections/amq_content_siegel.liquid).
 *
 * One dialog holds a Horizon slideshow with all badges; a badge button opens it at that badge:
 *   <button on:click="#<lightbox-id>/open/<index>">…</button>
 *   <amq-lightbox-component id="<lightbox-id>"><dialog ref="dialog">…</dialog></amq-lightbox-component>
 *
 * Everything else (Escape, backdrop click, focus handling, scroll lock, close button) comes
 * from Horizon's DialogComponent, which this element extends.
 */
class AmqLightboxComponent extends DialogComponent {
  /**
   * Opens the lightbox on the given slide.
   * @param {number | string} index - 0-based index of the slide to show.
   * @param {Event} [event] - The click event, if any.
   */
  open(index, event) {
    event?.preventDefault();

    const slideshow = this.querySelector('slideshow-component');
    const target = Number(index);

    if (slideshow && !Number.isNaN(target)) {
      // The dialog is display:none until showModal(); jump to the slide once it is open.
      this.addEventListener(
        'dialog:open',
        () => {
          slideshow.select(target, undefined, { animate: false });
        },
        { once: true }
      );
    }

    this.showDialog();
  }
}

if (!customElements.get('amq-lightbox-component')) {
  customElements.define('amq-lightbox-component', AmqLightboxComponent);
}
